module.exports = __webpack_public_path__ + "img/back-icon.2eadb4dd.svg";